import React, { useEffect, useRef, useState } from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from "moment-jalali";
import { useEntityCrud } from '../../hooks/useEntityCrud';


const OpinionSMS = () => {


    const { readData } = useEntityCrud('Report/SmsReport');
    const [filterItems, setFilterItems] = useState({});
    const [data, setData] = useState([]);

    const btnRef = useRef();
    const [issueDate, setIssueDate] = useState(null);
    const [expireDate, setExpireDate] = useState(null);

    const [advancedSearch, setAdvancedSearch] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    function convertToDate(date) {
        if (!date)
            return ""
        const dateString = moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYY-jMM-jDD").split("-");
        return dateString[0] + dateString[1] + dateString[2]
    }

    const getData = (otherPostedData = {}, filteredPostedData = {}) => {
        const postedData = {
            p_offset: currentPage,
            p_limit: 1000,
            ...otherPostedData
        }

        if (issueDate) {
            postedData.p_fromdate = convertToDate(issueDate)
        }
        if (expireDate) {
            postedData.p_todate = convertToDate(expireDate)
        }
        if (filteredPostedData.p_mobile) {
            postedData.p_mobile = filteredPostedData.p_mobile
        }
        if (filteredPostedData.p_nationalcode) {
            postedData.p_nationalcode = filteredPostedData.p_nationalcode
        }
        if (filteredPostedData.p_rrn) {
            postedData.p_rrn = filteredPostedData.p_rrn
        }
        if (filteredPostedData.p_cardno) {
            postedData.p_cardno = filteredPostedData.p_cardno
        }

        setLoading(true)
        btnRef.current.style.display = "none";


        readData(postedData).then(({ data }) => {
            setLoading(false)
            btnRef.current.style.display = "block";
            if (data.status && data.result.v_result) {

                setData(data.result.v_result)
                calcPages(data.result.v_count);

            } else {
                setData([]);
                setPages([]);
            }
        });
    }

    const submitFilter = () => {
        getData({}, filterItems);
        setAdvancedSearch(true);
    }

    const removeFilter = () => {
        setFilterItems(oldData => ({}));
        setAdvancedSearch(false);
        setLoading(false);
        setData([]);
        setExpireDate(null)
        setIssueDate(null)

    }

    const calcPages = result => {
        let calcPages = Math.floor(result?.count[0].cntTotal / 10);
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
    }

    const goToPage = (e, offset) => {
        e.preventDefault();
        setCurrentPage(offset);
        getData({ offset }, filterItems);
    }

    const goToPrevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        getData({ offset: currentPage - 1 }, filterItems);
    }

    const goToNextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        getData({ offset: currentPage + 1 }, filterItems);
    }

    return (
        <div className="col-md-12">
            <div className="card-body col-md-12  p-2 mx-auto mb-3 timeline-panel alert  ">
                <div className="row m-0">
                    <div className=' mt-3 mb-2 alert alert-info'>
                        <b>
                            <i className="fa fa-info mx-2 text-danger"></i>
                            وارد کردن
                            <span className='text-danger'> &nbsp;   تاریخ شروع  &nbsp;</span>
                            ,
                            <span className='text-danger'>  &nbsp; تاریخ پایان &nbsp; </span>
                            و همچنین
                            <span className='text-danger'>  &nbsp; یک ورودی &nbsp;</span>
                            دیگر به دلخواه
                            <span className='text-danger'>&nbsp; الزامی &nbsp;</span>
                            است.
                        </b>
                    </div>
                </div>
                <hr />
            </div>
            <div className="mb-0 borderRightContact py-3 px-3">
                <div className="panel panel-body  m-0 p-0 ">
                    <div className="row">
                        <div className="col-md-3 deskTopShow" style={{ position: "relative", zIndex: "8" }}>
                            <div className="form-group">
                                <label htmlFor="issueDate"> تاریخ شروع   </label><br />
                                {issueDate && <i class="fe fe-x clear-select-btn" onClick={() => setIssueDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    name="p_fromdate"
                                    required
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={issueDate}
                                    onChange={setIssueDate}
                                    className="form-control"
                                    inputPlaceholder=' تاریخ  شروع   را انتخاب کنید ...'
                                    calendarPopperPosition={"top"}
                                />
                            </div>
                        </div>
                        <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                            <div className="form-group">
                                <label htmlFor="p_todate"> تاریخ پایان   </label><br />
                                {expireDate && <i class="fe fe-x clear-select-btn" onClick={() => setExpireDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    name="p_todate"
                                    required
                                    locale="fa"
                                    calendarPopperPosition={"top"}
                                    shouldHighlightWeekends
                                    value={expireDate}
                                    onChange={setExpireDate}
                                    className="form-control"
                                    inputPlaceholder='  تاریخ پایان  را انتخاب کنید ...'
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>
                                    کد ملی
                                </label>
                                <input type="text" className="form-control ltr-input"
                                    value={filterItems.p_nationalcode || ''}
                                    minLength={10}
                                    maxLength={10}
                                    onChange={e => setFilterItems(oldData => ({ ...oldData, p_nationalcode: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>  شماره همراه </label>
                                <input type="tel" className="form-control ltr-input"
                                    value={filterItems.p_mobile || ''}
                                    onKeyUp={e => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    onChange={e => setFilterItems(oldData => ({ ...oldData, p_mobile: e.target.value }))} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group mb-0">
                                <label>شماره کارت</label>
                                <input type="tel" className="form-control ltr-input"
                                    value={filterItems.p_cardno || ''}
                                    onKeyUp={e => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    onChange={e => setFilterItems(oldData => ({ ...oldData, p_cardno: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group mb-0">
                                <label> کد ارجاع	</label>
                                <input type="tel" className="form-control ltr-input"
                                    value={filterItems.p_rrn || ''}
                                    onKeyUp={e => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    onChange={e => setFilterItems(oldData => ({ ...oldData, p_rrn: e.target.value }))} />
                            </div>
                        </div>
                        <div className="mt-4 col-md-6 pt-4" ref={btnRef}>
                            <button className="btn btn-cyan px-4 "
                                disabled={(issueDate && expireDate && (filterItems.p_mobile ||
                                    filterItems.p_nationalcode || filterItems.p_cardno || filterItems.p_rrn) !== undefined ?
                                    false : true)}
                                onClick={submitFilter}>
                                <i class="fa fa-search mx-2"></i>
                                جستجو
                            </button>
                            {advancedSearch &&
                                <button className="btn btn-danger mx-2 px-4"
                                    onClick={removeFilter}>
                                    <i class="mdi mdi-filter-variant mx-1"></i>
                                    حذف فیلتر
                                </button>}
                        </div>
                    </div>

                </div>
            </div>

            {isLoading ?
                <div style={{ minHeight: "100px" }}>
                    <div className="lds-facebook my-4" >
                        <div></div>
                        <div></div>
                        <div></div>
                    </div >
                </div>
                :
                <>

                    {data.length > 0 && <div className=' mt-2' style={{ padding: "20px 5px", margin: "1% 3% !important" }}>
                        <h4 class="title current mt-1 d-flex justify-content-between ">
                            <div> <i className="fa fa-align-justify"></i> لیست  پیامک ها </div>
                        </h4>
                        {data.length > 0 ?
                            <div className="table-responsive bg-white p-4" style={{ borderRadius: 7 }}>
                                <table className="table custom-table-style table-bordered table-hover mb4">
                                    <thead className="table-primary ">
                                        <tr>
                                            <th> ردیف </th>
                                            <th>     نام و نام خانوادگی  </th>
                                            <th>   نام کسب و کار   </th>
                                            <th>    شماره موبایل      </th>
                                            <th> شماره کارت    </th>
                                            <th>    کد ملی </th>
                                            <th> شماره ارجاع </th>
                                            <th> زمان ارسال </th>
                                             <th>       وضعیت پیامک   </th>
                                             <th>     متن پیام   </th>

                                         </tr>
                                    </thead>

                                    <tbody>
                                        {data?.map((call, index) => (
                                            <tr key={'call-' + index}>
                                                <td>{index + 1}</td>
                                                <td> {call.full_name || '-'} </td>
                                                <td> {call.business_title || '-'} </td>                                                
                                                <td> {call.consumer_mobile || '-'} </td>
                                                <td dir='ltr'> {call.cardno || '-'} </td>
                                                <td> {call.nationalcode || '-'} </td>
                                                <td> {call.rrn || '-'}</td>
                                                <td>  {moment(call.register_date, "jYYYYjMMjDD HH:mm:ss.SSSZ").format("HH:mm - jYYYY/jMM/jDD")}</td>
                                                <td> {call.status || '-'}</td>
                                                <td>
                                                    <button className="btn btn-icon mb-0 btn-info" data-bs-toggle="modal" href={`#modaldemo${call.rrn}`}>
                                                        <i className="fe fe-eye"></i></button>
                                                </td>


                                                <div class="modal fade" id={`modaldemo${call.rrn}`}>
                                                    <div class="modal-dialog modal-dialog-centered " role="document">
                                                        <div class="modal-content modal-content-demo">
                                                            <div class="modal-header">
                                                                <h6 class="modal-title">  متن پیامک به شماره ارجاع {call.rrn}  </h6>
                                                                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal">
                                                                    <span aria-hidden="true ">&times;</span></button>
                                                            </div>
                                                            <div class="modal-body text-right my-4">
                                                                <p>
                                                                    {call.msg_body} 
                                                                </p>
                                                            </div>
                                                           
                                                        </div>
                                                    </div>
                                                </div>

                                                {/*   <td title={call.msg_body}>
                                                    {call.msg_body?.length > 15 ?
                                                        `${call.msg_body.substring(0, 15)}...` : call.msg_body
                                                    } </td> */}
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>

                                {pages.length > 1 &&
                                    <ul className="pagination mt-3 mb-1">
                                        {currentPage > 1 &&
                                            <li className="page-item">
                                                <a className="page-link" href="#" onClick={e => setCurrentPage(1)}>
                                                    <i className="icon ion-ios-arrow-forward"></i>
                                                    <i className="icon ion-ios-arrow-forward"></i>
                                                </a>
                                            </li>}
                                        {currentPage > 1 &&
                                            <li className="page-item">
                                                <a className="page-link" href="#" onClick={e => goToPrevPage(e)}>
                                                    <i className="icon ion-ios-arrow-forward"></i>
                                                </a>
                                            </li>}

                                        {pages
                                            .filter((page) => Math.abs(page - currentPage) < 7)
                                            .map((page, index) => (
                                                <li
                                                    key={index}
                                                    onClick={(e) => goToPage(e, page)}
                                                    className={"page-item" + (page == currentPage ? " active" : "")}
                                                >
                                                    <a className="page-link" href="#">
                                                        {page}
                                                    </a>
                                                </li>
                                            ))}
                                        {pages.length > currentPage + 7 && (
                                            <>
                                                <li className={"page-item"}>
                                                    <a className="page-link">
                                                        ...
                                                    </a>
                                                </li>
                                                <li
                                                    onClick={(e) => goToPage(e, pages.length)}
                                                    className={"page-item"}
                                                >
                                                    <a className="page-link" href="#">
                                                        {pages.length}
                                                    </a>
                                                </li>
                                            </>
                                        )}


                                        {pages.length > 1 && currentPage != pages.length &&
                                            <li className="page-item">
                                                <a className="page-link" href="#" onClick={e => goToNextPage(e)}>
                                                    <i className="icon ion-ios-arrow-back"></i>
                                                </a>
                                            </li>}

                                        {pages.length > 1 && currentPage != pages.length &&
                                            <li className="page-item">
                                                <a className="page-link" href="#" onClick={e => setCurrentPage(pages.length)}>
                                                    <i className="icon ion-ios-arrow-back"></i>
                                                    <i className="icon ion-ios-arrow-back"></i>
                                                </a>
                                            </li>}
                                    </ul>}


                            </div> :
                            <p>
                                دیتایی یافت نشد!
                            </p>
                        }
                    </div>
                    }
                </>
            }
        </div >
    )
}

export default OpinionSMS;
